const initForTests = (app) => {
    if (window.navigator.userAgent.includes('cypress')) {
        app.config.errorHandler = window.onerror;
    }
};

export default initForTests;
